import { ACdetails, useCampaignContext } from 'context/CampaignContext';
import { usePortalContext } from 'context/PortalContext';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { useLoggingActivity } from '../../../../customHooks/useLogging';
import { ReactComponent as SVG_DIGITAL } from '../../../../assets/newAssets/Property 1=digital.svg';
import { ReactComponent as SVG_SEARCH } from '../../../../assets/newAssets/search.svg';
import { ReactComponent as SVG_OOH_KAMPAGNE } from '../../../../assets/newAssets/Property 1=ooh.svg';
import { ReactComponent as SVG_PRINT } from '../../../../assets/newAssets/Property 1=print.svg';
import { ReactComponent as SVG_RADIO } from '../../../../assets/newAssets/Property 1=radio.svg';
import { ReactComponent as SVG_TV } from '../../../../assets/newAssets/Property 1=video.svg';
import { ReactComponent as SVG_CINEMA } from '../../../../assets/SVG/cinema.svg';
import { ReactComponent as SVG_PUBLISHED } from '../../../../assets/newAssets/checkmarkCircle.svg';
import { DashboardTypes, FlowchartCampaignStatus, GetQueriesQuery } from 'API';
import { QueryInfo } from '../Brief/Brief';
import { API } from 'aws-amplify';
import { getQueries } from 'graphql/queries';
import DocumentUploader from './DocumentUploader';
import { useTab } from 'customHooks/useParameters';
import { useClientContext } from 'context/ClientContext';
import { iconList } from 'assets/newAssets/SVG/additionalIconsForLinks/iconList';
// import { useEnrichedContext } from 'context/EnrichedContext';

type Props = {
  uploadedFiles: QueryInfo[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<QueryInfo[]>>;
  isClient: boolean;
  fullAccess: boolean;

  isUserAuthorized: boolean | undefined;
};
interface ContainerProps {
  active?: string;
  theme: any;
}

const ReportsContainer = styled.div<ContainerProps>`
  display: flex;
  gap: 0.6vw;
  padding: 1vw 0 0vw 0.3vw;

  .IsDisabled {
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.1);
    pointer-events: none;
    cursor: not-allowed;
  }
`;
export const IconContainer = styled.div<ContainerProps>`
  position: relative;
  padding: 1vw;
  border: 1px solid ${(props) => (props.active === 'true' ? props.theme.brand : props.theme.border)};
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  aspect-ratio: 1 / 1;
  width: 5vw;
  height: 5vw;
  cursor: ${(props) => (props.active === 'true' ? 'pointer' : 'default')};
  pointer-events: ${(props) => (props.active === 'false' ? 'none' : 'default')};

  .green {
    color: #e8eaef !important;
  }

  h2 {
    font-size: 0.7vw;
    font-family: 'fontRegular';
    font-weight: normal;
    text-align: center;
    color: ${(props) => (props.active === 'true' ? props.theme.brand : props.theme.border)};
  }

  .svg {
    height: 2vw;
    fill: ${(props) => (props.active === 'true' ? props.theme.brand : props.theme.border)};
    // stroke-width: 5px;
    width: 1.5vw;

    path {
      stroke: ${(props) => (props.active === 'true' ? props.theme.brand : props.theme.border)};
      stroke-width: 0.1;
    }
  }
  .stampPublished {
    display: ${(props) => (props.active === 'true' ? 'block' : 'none')};
    position: absolute;
    bottom: -10px;
    right: -10px;
    fill: green;
    background-color: ${({ theme }) => theme.placeholderBackground};
  }
  .stampNOTPublished {
    display: ${(props) => (props.active === 'true' ? 'block' : 'none')};
    position: absolute;
    bottom: -10px;
    right: -10px;
    fill: ${({ theme }) => theme.c400};
    background-color: ${({ theme }) => theme.placeholderBackground};
  }

  .material-symbols-outlined {
    font-variation-settings:
      'FILL' 0,
      'wght' 600,
      'GRAD' 0,
      'opsz' 48;
    display: flex;
    justify-content: center;
    align-items: center;
    /* width: 100%;
    height: 100%; */
    font-size: 1.5vw; /* Adjust the font size as needed */
    color: ${({ theme }) => theme.brand};
    text-align: center;
    line-height: 1; /* Ensure the line height does not affect the size */
  }
`;

export const checkIfPublished = (type: string, activeCampaign: any) => {
  // console.log('activeCampaign', activeCampaign, type);

  const arr: any = [];

  // Definiraj koje tipove treba provjeriti
  let typesToCheck: string[] = [];
  if (type === 'Video') {
    typesToCheck = ['TV', 'BVOD'];
  } else if (type === 'Audio') {
    typesToCheck = ['RADIO'];
  } else {
    typesToCheck = [type.toUpperCase()];
  }

  if (activeCampaign?.subcampaign) {
    for (const [, value] of Object.entries(activeCampaign.subcampaign)) {
      const publishedobj = (value as any).published;
      // Provjeri sve tipove za ovaj type
      typesToCheck.forEach((typeToCheck) => {
        arr.push(publishedobj[typeToCheck]);
      });

      if (activeCampaign?.childCampaigns && activeCampaign?.childCampaigns.length > 0) {
        activeCampaign?.childCampaigns.forEach((child: any) => {
          if (child?.subcampaign) {
            for (const [, value] of Object.entries(child.subcampaign)) {
              const publishedobj = (value as any).published;
              typesToCheck.forEach((typeToCheck) => {
                arr.push(publishedobj[typeToCheck]);
              });
            }
          }
        });
      }
      if (activeCampaign?.campaignPeriods && activeCampaign?.campaignPeriods.length > 0) {
        activeCampaign?.campaignPeriods.forEach((period: any) => {
          if (period?.subcampaign) {
            for (const [, value] of Object.entries(period.subcampaign)) {
              const publishedobj = (value as any).published;
              typesToCheck.forEach((typeToCheck) => {
                arr.push(publishedobj[typeToCheck]);
              });
            }
          }
        });
      }
    }
  }
  return arr.some((e: boolean) => e === true);
};

const ReportsLinks = (props: Props) => {
  const { uploadedFiles, setUploadedFiles, isUserAuthorized } = props;
  const themee = useTheme();
  const { activeCampaign, setDashType } = useCampaignContext();
  const { userCanDoInsource } = useClientContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setDrawerIsOpen } = usePortalContext();
  const navigate = useNavigate();
  const [tab] = useTab();
  const logActivity = useLoggingActivity();
  // const { fullSources } = useEnrichedContext();

  const handleClick = async (link: string) => {
    // Determine action based on link
    let action = 'DASHBOARD_CLICK'; // Default action
    if (link === '/reporting/portal') {
      action = 'CLIENT_OVERVIEW';
    }

    // Log activity for navigation
    try {
      const search = searchParams.toString();
      const targetUrl = `${window.location.origin}${link}?${search}`;
      logActivity({
        action: action,
        url: targetUrl,
      }).catch(console.error);
    } catch (error) {
      console.error('Failed to log activity:', error);
    }

    if (link === '/reporting/onlinePortal') {
      setDashType(DashboardTypes.DIGITAL);
    } else if (link === '/reporting/TVPortal') {
      setDashType(DashboardTypes.TV);
    } else if (link === '/reporting/radioPortal') {
      setDashType(DashboardTypes.RADIO);
    } else if (link === '/reporting/printPortal') {
      setDashType(DashboardTypes.PRINT);
    } else if (link === '/reporting/OOHPortal') {
      setDashType(DashboardTypes.OOH);
    } else if (link === '/') {
      setDashType(DashboardTypes.HOME);
    } else if (link === '/reporting/portal') {
      setDashType(DashboardTypes.FLOWCHART);
    } else if (link === '/reporting/cinemaPortal') {
      setDashType(DashboardTypes.CINEMA);
    } else if (link === '/reporting/searchPortal') {
      setDashType(DashboardTypes.SEARCH);
    }
    searchParams.delete('tab');
    console.log('subcamp', searchParams.get('subcampaignID'));
    setSearchParams(searchParams);
    setDrawerIsOpen(false);
    const search = searchParams.toString();
    const url = `${link}?${search}`;

    navigate(url, {
      state: { tab: tab },
    });
  };

  const reportIconList = [
    {
      name: 'Digital',
      icon: SVG_DIGITAL,
      link: '/reporting/onlinePortal',
    },
    {
      name: 'Search',
      icon: SVG_SEARCH,
      link: '/reporting/searchPortal',
    },
    {
      name: 'Video',
      icon: SVG_TV,
      link: '/reporting/TVPortal',
    },
    {
      name: 'Audio',
      icon: SVG_RADIO,
      link: '/reporting/radioPortal',
    },
    {
      name: 'Print',
      icon: SVG_PRINT,
      link: '/reporting/printPortal',
    },
    {
      name: 'OOH',
      icon: SVG_OOH_KAMPAGNE,
      link: '/reporting/OOHPortal',
    },
    {
      name: 'Cinema',
      icon: SVG_CINEMA,
      link: '/reporting/cinemaPortal',
    },
  ];

  useEffect(() => {
    async function fetchUploadedFiles(): Promise<QueryInfo[]> {
      try {
        const response = (await API.graphql({
          query: getQueries,
          variables: {
            campaign_id: activeCampaign?.campaignId?.toString(10),
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        })) as { data: GetQueriesQuery };

        if (response.data.getQueries) {
          const res = response.data.getQueries;
          const queries = res.filter((query) => query?.position?.includes('SummaryUploadFile'));
          return queries.map((q) => {
            return { id: q?.query_id ?? '', position: q?.position ?? '', name: q?.query_id?.split('_')[1] ?? '' };
          });
        }
        return [] as QueryInfo[];
      } catch (e) {
        console.error('ERROR FETCHING QUARIES', e);
        return [] as QueryInfo[];
      }
    }

    const addToFileList = async () => {
      const queryInfos = await fetchUploadedFiles();
      setUploadedFiles(queryInfos);
    };

    if (activeCampaign && searchParams.get('tab') === 'summary') {
      addToFileList();
    }
  }, [activeCampaign, searchParams, setUploadedFiles]);

  const [bubleVisible, setBubleVisible] = useState(false);
  const handleBuble = () => {
    setBubleVisible(!bubleVisible);
    setTimeout(() => {
      setBubleVisible(false);
    }, 3000);
  };
  const creatorIcon = iconList.find((icon) => icon === 'screen_share');

  const InsourceElement = (
    <>
      <IconContainer onClick={() => handleClick('/reporting/insourceDataPortal')} active={'true'} theme={themee}>
        <div className="svg material-symbols-outlined  ">{creatorIcon}</div>
        <h2>Insource Data</h2>
      </IconContainer>
    </>
  );

  return (
    <ReportsContainer>
      {reportIconList.filter((rep) => (!isUserAuthorized ? checkIfPublished(rep.name, activeCampaign) : rep)).length ===
      0 ? (
        <div className="error">
          <h4>No dashboards are available at the moment.</h4>
          {userCanDoInsource && activeCampaign?.dashboardType.some((e) => e === 'INSOURCE_DATA') && (
            <>
              <h4>Dashboards available with your own data:</h4>
              {InsourceElement}
            </>
          )}
        </div>
      ) : (
        <>
          {reportIconList
            .filter((rep) => (!isUserAuthorized ? checkIfPublished(rep.name, activeCampaign) : rep))
            .map((item) => {
              return (
                <React.Fragment key={item.name}>
                  <IconContainer
                    onClick={() =>
                      !isUserAuthorized && !checkIfPublished(item.name, activeCampaign)
                        ? handleBuble()
                        : handleClick(item.link)
                    }
                    active={activeCampaign?.dashboardType
                      // .filter((a) => {
                      //   if (a === 'TV' && !fullSources?.some((s) => s.source_name === 'DATASOURCE#ADE')) {
                      //     return false;
                      //   } else {
                      //     return a;
                      //   }
                      // })
                      .some(
                        (e) =>
                          (e === 'TV' || e === 'BVOD' ? 'VIDEO' : e === 'RADIO' ? 'AUDIO' : e) ===
                          item.name.toUpperCase(),
                      )
                      .toString()}
                    theme={themee}
                  >
                    <item.icon className="svg"></item.icon>
                    {checkIfPublished(item.name, activeCampaign) && (
                      <SVG_PUBLISHED className="stampPublished"></SVG_PUBLISHED>
                    )}
                    <h2>{item.name}</h2>
                  </IconContainer>
                  <span className="buble">
                    <span className="bubletext" style={{ visibility: bubleVisible ? 'visible' : 'hidden' }}>
                      "This campaign has yet to be evaluated."
                    </span>
                  </span>
                </React.Fragment>
              );
            })}

          {userCanDoInsource && activeCampaign?.dashboardType.some((e) => e === 'INSOURCE_DATA') && InsourceElement}
        </>
      )}

      <>
        <>
          <DocumentUploader uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles}></DocumentUploader>
        </>
      </>
    </ReportsContainer>
  );
};

export default ReportsLinks;
